// @ts-nocheck
import clsx from "clsx";
import React from "react";
import Button from "../../../components/Button";
import { ButtonProps } from "../../../components/Button";
import { Theme } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme: Theme) => ({
  action: {
    fontSize: 16,
    borderRadius: 20,
    width: 80,
    fontWeight: 600,
  },
  iconContainer: {
    marginBottom: theme.spacing(4),
  },
  actionsWrapper: {
    "& > button": {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
    "& > button:first-child": {
      marginLeft: 0,
    },
    "& > button:last-child": {
      marginRight: 0,
    },
  },
  divRoot: {
    top: 0,
    left: 0,
    borderRadius: 10,
    zIndex: 5000,
    width: "100%",
    height: "100%",
    position: "absolute",
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    boxShadow: "0 2px 14px 0 rgba(0, 0, 0, 0.16)",
  },
  root: {
    flexGrow: 1,
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  message: {
    fontSize: 16,
    marginBottom: 45,
    fontWeight: 600,
    color: "#231f20",
  },
  backdrop: {
    backdropFilter: "blur(2px)",
    zIndex: theme.zIndex.modal,
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    boxShadow: "0 2px 14px 0 rgba(0, 0, 0, 0.16)",
  },
}));

export default function BlurredBackdrop({
  icon,
  open,
  message,
  actions,
  className,
}: {
  icon?: any;
  open?: boolean;
  message?: string;
  className?: string;
  actions?: (ButtonProps & { btnText: string })[];
}) {
  const classes = useStyles();
  return (
    <Backdrop
      open={open}
      timeout={500}
      className={clsx(classes.backdrop, className)}
    >
      <Typography align="center" component="div" className={classes.root}>
        {icon && (
          <Typography component="div" className={classes.iconContainer}>
            {icon}
          </Typography>
        )}
        {message && (
          <Typography component="p" className={classes.message}>
            Check Your Mailbox.
          </Typography>
        )}
        {!!actions.length && (
          <Typography component="div" className={classes.actionsWrapper}>
            {actions.map(({ btnText, className, ...rest }, index) => (
              <Button
                {...rest}
                key={`BackdropAction_${index}`}
                className={clsx(classes.action, className)}
              >
                {btnText}
              </Button>
            ))}
          </Typography>
        )}
      </Typography>
    </Backdrop>
  );
}

export function DesktopBlurredBackdrop({
  icon,
  message,
  actions,
  className,
}: {
  icon?: any;
  message?: string;
  className?: string;
  actions?: (ButtonProps & { btnText: string })[];
}) {
  const classes = useStyles();

  return (
    <Typography component="div" className={clsx(classes.divRoot, className)}>
      <Typography align="center" component="div" className={classes.root}>
        {icon && (
          <Typography component="div" className={classes.iconContainer}>
            {icon}
          </Typography>
        )}
        {message && (
          <Typography component="p" className={classes.message}>
            Check Your Mailbox.
          </Typography>
        )}
        {!!actions.length && (
          <Typography component="div" className={classes.actionsWrapper}>
            {actions.map(({ btnText, className, ...rest }, index) => (
              <Button
                {...rest}
                key={`BackdropAction_${index}`}
                className={clsx(classes.action, className)}
              >
                {btnText}
              </Button>
            ))}
          </Typography>
        )}
      </Typography>
    </Typography>
  );
}
